import React, { useState } from 'react';
import { Chip, Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { AccountData, PhoneSuggestionData } from '../../../../../api';
import { useAuth } from '../../../../../session/InternalAuthProvider';
import PersonalDetailsStep from '../../components/personalDetailsPanel/PersonalDetailsStep';
import { OrderPageIntent } from '../../OrderPageIntent';
import { EditOrderFormValues } from '../../EditOrderDialog';
import { PhoneSuggestField } from '../components/PhoneSuggestField';
// @ts-ignore
import { useEditOrder } from '../../EditOrderContext';

export const CustomerStep = () => {
  const { t } = useTranslation();
  const { authState } = useAuth();
  const account = authState.account as unknown as AccountData;
  // @ts-ignore
  const { editOrderState, setOrderCustomDetails } = useEditOrder();
  const { values } = useFormikContext<EditOrderFormValues>();
  const [pickedSuggestion, setPickedSuggestion] = useState<PhoneSuggestionData | null>(null);

  const isFilledFromPastOrder =
    pickedSuggestion !== null &&
    values.phone === pickedSuggestion.phone &&
    values.firstname === pickedSuggestion.firstname &&
    values.lastname === pickedSuggestion.lastname;

  return (
    <PersonalDetailsStep
      orderPage={editOrderState.orderPage}
      orderPageIntent={OrderPageIntent.BUY_NOW}
      setOrderCustomDetails={setOrderCustomDetails}
      holidayCalendar={account.holiday_calendar}
      showReferralSource={false}
      renderPhoneField={() => (
        <Grid container flexDirection="column" gap={1}>
          <PhoneSuggestField onSuggestionPicked={setPickedSuggestion} />
          {isFilledFromPastOrder && (
            <Chip
              size="small"
              color="success"
              variant="outlined"
              label={t('calendar.create_order.filledFromPastOrder')}
              sx={{ alignSelf: 'flex-start' }}
            />
          )}
        </Grid>
      )}
    />
  );
};
